import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import WidgetPost from "./widget/WidgetPost";
import WidgetCategory from "./widget/WidgetCategory";
import {
  FaSearch,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaPinterest,
  FaYoutube,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { media_url } from "../../hooks/useBlog";

const BlogSidebar = () => {
  const { posts, currentPost, snippets, videos } = useSelector(
    (state) => state.blog
  );
  const [viewState, setViewState] = useState({
    currentVideo: null,
  });
  const initialized = useRef(false);
  useEffect(() => {
    if (videos && videos.length > 0 && !viewState.currentVideo) {
      setViewState((prev) => ({
        ...prev,
        currentVideo: videos[0].id,
      }));
    }
  }, [videos]);
  return (
    <div className="gc-sidebar">
      <div className="widget widget-search">
        <h4 className="widget-title">Buscar</h4>
        <form
          action="#"
          className="blog-search"
          onSubmit={(e) => e.preventDefault()}
        >
          <input type="text" placeholder="Buscar" />
          <button className="search-button">
            <FaSearch />
          </button>
        </form>
      </div>
      {/* <div className="widget widget-categories">
                <h4 className="widget-title">Categories</h4>
                <WidgetCategory />
            </div> */}
      <div className="widget widge-social-share">
        <div className="blog-share">
          <h5 className="title">Redes:</h5>
          <ul className="social-list list-unstyled">
            <li>
              <a href="https://facebook.com/">
                <FaFacebookF />
              </a>
            </li>
            <li>
              <a href="https://twitter.com/">
                <FaXTwitter />
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/">
                <FaInstagram />
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/">
                <FaLinkedinIn />
              </a>
            </li>
            <li>
              <a href="https://www.pinterest.com/">
                <FaPinterest />
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/">
                <FaYoutube />
              </a>
            </li>
          </ul>
        </div>
      </div>
      {videos && videos.length > 0 && (
        <div className="widget widget-video">
          <h4 className="widget-title">Videos Recientes</h4>
          {/* show horizontal scroll with videos thumbnail */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              height: "100px",
              overflowX: "auto",
              scrollbarWidth: "thin",
              msOverflowStyle: "none",
              "&::-webkit-scrollbar": {
                display: "none",
              },
              paddingBottom: "10px",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            {videos.map((video, i) => (
              <div
                style={{
                  backgroundImage: `url(${media_url(video.thumbnail)})`,
                  backgroundColor: video.thumbnail ? "transparent" : "#000",
                  backgroundSize: "cover",
                  height: "60px",
                  borderRadius: "30px",
                  width: "60px",
                  marginRight: "10px",
                  cursor: "pointer",
                  border:
                    viewState.currentVideo === video.id
                      ? "2px solid blue"
                      : "2px solid transparent",
                }}
                onClick={() => {
                  setViewState((prev) => ({
                    ...prev,
                    currentVideo: video.id,
                  }));
                  //   pause all videos
                  const videoElements = document.querySelectorAll("video");
                  videoElements.forEach((el) => {
                    if (el.id !== `video-player-${i}`) {
                      el.pause();
                    }
                  });
                }}
                key={i}
              ></div>
            ))}
          </div>
          {videos.map((video, i) => {
            if(video.url ){
              return (
                <iframe
                  key={i}
                  width="100%"
                  height="auto"
                  src={video.url}
                  title="video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                  style={{
                    display:
                      viewState.currentVideo === video.id ? "block" : "none",
                      minHeight: "200px",
                  }}
                />
              );
            }
            return (
              <video
                key={i}
                id={`video-player-${i}`}
                width="100%"
                height="auto"
                style={{
                  display:
                    viewState.currentVideo === video.id ? "block" : "none",
                }}
                //   add listener on video element to pause on change display

                controls
                src={video.url ? video.url : media_url(video.video)}
              />
            );
          })}
        </div>
      )}
      {snippets &&
        snippets.length > 0 &&
        snippets
          .filter((s) => s.enabled && s.position === "post_side")
          .map((snippet, i) => (
            <div
              className="widget widget-snippet"
              key={i}
              style={{
                width: "100%",
                height: "auto",
                backgroundColor: "transparent",
              }}
            >
              <div dangerouslySetInnerHTML={{ __html: snippet.html }}></div>
              {snippet.script && (
                <div dangerouslySetInnerHTML={{ __html: snippet.script }}></div>
              )}
            </div>
          ))}
      <div className="widget widget-recent-post">
        <h4 className="widget-title">Noticias Recientes</h4>
        <WidgetPost />
      </div>
      {/* <div className="widget widget-banner-ad">
                <Link to="#">
                    <img src={process.env.PUBLIC_URL + "/images/banner/widget-banner.png"} alt="banner" />
                </Link>
            </div> */}
    </div>
  );
};

export default BlogSidebar;
